import React from "react";
import "./ShortAbout.css";

export default function ShortAbout() {
  return (
    <section className="about-section">
      <div className="container">

        <div className="about-header">
          <h2>About GlassHopeOne Technologies Pvt. Ltd.</h2>
          <p>
            At GlassHopeOne, we empower businesses to thrive in the digital era.
            Our expertise spans enterprise software, SaaS platforms, AI-driven
            solutions, cloud infrastructure, and industrial automation.
          </p>
        </div>

        <div className="about-content">

          <div className="about-card">
            <h3>Our Mission</h3>
            <p>
              To empower businesses with cutting-edge software and SaaS platforms
              that streamline operations.
            </p>

            <h3>Our Vision</h3>
            <p>
              To be a global leader in future-ready technology solutions.
            </p>
          </div>

          <div className="about-card values-card">
            <h3>Our Core Values</h3>
            <ul>
              <li><strong>Innovation:</strong> AI, ML, IoT driven solutions</li>
              <li><strong>Excellence:</strong> High standards & quality</li>
              <li><strong>Client Success:</strong> Tailored solutions</li>
              <li><strong>Integrity:</strong> Ethical practices</li>
              <li><strong>Collaboration:</strong> Team-driven innovation</li>
            </ul>
          </div>

        </div>
      </div>
    </section>
  );
}
